module.exports = __webpack_public_path__ + "img/showroom_in.a6d38733.svg";